import {
  PROPOSE_UNAPPROVED_LIST_SEARCH, PROPOSE_UNAPPROVED_LIST_SEARCH_FAILURE, PROPOSE_UNAPPROVED_LIST_SEARCH_SUCCESS,
  PROPOSE_APPROVED_LIST_SEARCH, PROPOSE_APPROVED_LIST_SEARCH_FAILURE, PROPOSE_APPROVED_LIST_SEARCH_SUCCESS,
  PROPOSE_COUNT, PROPOSE_COUNT_FAILURE, PROPOSE_COUNT_SUCCESS
} from './mutation-types'

export default {
  state: {
    proposeUnapprovedList: [],
    proposeUnapprovedListNextPage: null,
    proposeUnapprovedListCurrentPage: null,
    proposeUnapprovedTotalCount: 0,
    proposeApprovedList: [],
    proposeApprovedListNextPage: null,
    proposeApprovedListCurrentPage: null,
    proposeApprovedTotalCount: 0
  },
  getters: {
    proposeUnapprovedList: state => {
      return state.proposeUnapprovedList
    },
    proposeUnapprovedListNextPage: state => {
      return state.proposeUnapprovedListNextPage
    },
    proposeUnapprovedListCurrentPage: state => {
      return state.proposeUnapprovedListCurrentPage
    },
    proposeApprovedList: state => {
      return state.proposeApprovedList
    },
    proposeApprovedListNextPage: state => {
      return state.proposeApprovedListNextPage
    },
    proposeApprovedListCurrentPage: state => {
      return state.proposeApprovedListCurrentPage
    },
    proposeUnapprovedTotalCount: state => {
      return state.proposeUnapprovedTotalCount
    },
    proposeApprovedTotalCount: state => {
      return state.proposeApprovedTotalCount
    }
  },
  actions: {
    [PROPOSE_UNAPPROVED_LIST_SEARCH] ({dispatch, state, commit}, params) {
      let data = {}
      let url = '/master/proposes'
      let callback = () => {}
      if (params) {
        if (params.url) {
          url = params.url
        }
        if ('callback' in params) {
          callback = params.callback
        }
        data = params.data
      }
      dispatch('apiGet', {url: url, data: data, loadparams: true})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(PROPOSE_UNAPPROVED_LIST_SEARCH_FAILURE, {data: res.data, callback: callback})
          } else {
            commit(PROPOSE_UNAPPROVED_LIST_SEARCH_SUCCESS, {data: res.data, callback: callback})
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [PROPOSE_APPROVED_LIST_SEARCH] ({dispatch, state, commit}, params) {
      let data = {}
      let url = '/master/proposes'
      let callback = () => {}
      if (params) {
        if (params.url) {
          url = params.url
        }
        if ('callback' in params) {
          callback = params.callback
        }
        data = params.data
      }
      dispatch('apiGet', {url: url, data: data, loadparams: true})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(PROPOSE_APPROVED_LIST_SEARCH_FAILURE, {data: res.data, callback: callback})
          } else {
            commit(PROPOSE_APPROVED_LIST_SEARCH_SUCCESS, {data: res.data, callback: callback})
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [PROPOSE_COUNT] ({dispatch, state, commit}, params = null) {
      dispatch('apiGet', {url: '/master/proposes/count', data: params.data})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(PROPOSE_COUNT_FAILURE, res.data)
          } else {
            commit(PROPOSE_COUNT_SUCCESS, {data: res.data, callback: params.callback})
          }
        }
      })
      .catch(error => {
        throw error
      })
    }
  },
  mutations: {
    [PROPOSE_UNAPPROVED_LIST_SEARCH_FAILURE] (state, params) {
      console.log('PROPOSE_UNAPPROVED_LIST_SEARCH_FAILURE')
      if (params.callback) {
        params.callback()
      }
    },
    [PROPOSE_UNAPPROVED_LIST_SEARCH_SUCCESS] (state, params) {
      console.log('PROPOSE_UNAPPROVED_LIST_SEARCH_SUCCESS')
      const data = params.data
      if (data.meta && data.meta['current-page'] && data.meta['current-page'] > 1) {
        state.proposeUnapprovedList = state.proposeUnapprovedList.concat(data.data)
        state.proposeUnapprovedListCurrentPage = data.meta['current-page']
        state.proposeUnapprovedTotalCount = data.meta['total-count']
      } else {
        state.proposeUnapprovedList = data.data
        state.proposeUnapprovedListCurrentPage = 1
        state.proposeUnapprovedTotalCount = data.meta['total-count']
      }
      if (params.callback) {
        params.callback()
      }
    },
    [PROPOSE_APPROVED_LIST_SEARCH_FAILURE] (state, params) {
      console.log('PROPOSE_APPROVED_LIST_SEARCH_FAILURE')
      if (params.callback) {
        params.callback()
      }
    },
    [PROPOSE_APPROVED_LIST_SEARCH_SUCCESS] (state, params) {
      console.log('PROPOSE_APPROVED_LIST_SEARCH_SUCCESS')
      const data = params.data
      let reSearch = false
      if (data.meta && data.meta['re-search']) {
        reSearch = data.meta['re-search']
      }
      if (reSearch) {
        // 再検索
        state.proposeApprovedList = data.data
      } else {
        if (data.meta && data.meta['current-page'] && data.meta['current-page'] > 1) {
          state.proposeApprovedList = state.proposeApprovedList.concat(data.data)
          state.proposeApprovedListCurrentPage = data.meta['current-page']
          state.proposeApprovedListNextPage = data.meta['next-page']
          state.proposeApprovedTotalCount = data.meta['total-count']
        } else {
          state.proposeApprovedList = data.data
          state.proposeApprovedListCurrentPage = 1
          state.proposeApprovedListNextPage = data.meta['next-page']
          state.proposeApprovedTotalCount = data.meta['total-count']
        }
      }
      if (params.callback) {
        params.callback()
      }
    },
    [PROPOSE_COUNT_FAILURE] (state, data) {
      console.log('PROPOSE_COUNT_FAILURE')
    },
    [PROPOSE_COUNT_SUCCESS] (state, params) {
      console.log('PROPOSE_COUNT_SUCCESS')
      if (params.callback) {
        params.callback(params.data)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/propose-list.js